export * from './useExtensionsSetupRegistry';
